import React from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import classNames from "classnames";
import { Field } from "redux-form";
import {
  FormRow,
  NumberInput,
  CurrencyField
} from "MODULES/shared/components/Forms";

export function InsuranceTypeField({
  amount_insured: amountInsured,
  percent_insured: percentInsured,
  insurance_type: insuranceType,
  disabled
}) {
  const activePercent = classNames("btn btn-default", {
    active: insuranceType.input.value === "Percent"
  });
  const activeAmount = classNames("btn btn-default", {
    active: insuranceType.input.value === "Amount"
  });
  const activeNone = classNames("btn btn-default", {
    active: insuranceType.input.value === "None"
  });

  const handleInsuranceTypeChange = newVal => () => {
    if (disabled) return;
    insuranceType.input.onChange(newVal);
    if (newVal === "Amount") {
      percentInsured.input.onChange(null);
    } else if (newVal === "Percent") {
      amountInsured.input.onChange(null);
    } else {
      amountInsured.input.onChange(null);
      percentInsured.input.onChange(null);
    }
  };

  return (
    <div className="form-group" style={{ marginBottom: 20 }}>
      <label className="control-label" htmlFor="insurance_type">
        Insurance
      </label>
      <div className="btn-group btn-group-justified" role="group">
        <div
          className={activeNone}
          disabled={disabled}
          onClick={handleInsuranceTypeChange("None")}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;&nbsp;Do Not Insure
        </div>
        <div
          className={activeAmount}
          disabled={disabled}
          onClick={handleInsuranceTypeChange("Amount")}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;&nbsp;Amount
        </div>
        <div
          className={activePercent}
          disabled={disabled}
          onClick={handleInsuranceTypeChange("Percent")}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;&nbsp;Percent
        </div>
      </div>
    </div>
  );
}

InsuranceTypeField.propTypes = {
  amount_insured: PropTypes.instanceOf(Object),
  percent_insured: PropTypes.instanceOf(Object),
  insurance_type: PropTypes.instanceOf(Object),
  disabled: PropTypes.bool
};

function AmountInsuredFields({ amount, disabled }) {
  return (
    <div className="col-md-4">
      <CurrencyField
        name={amount.input.name}
        label="Insurance Amount"
        disabled={disabled}
        required
      />
    </div>
  );
}

AmountInsuredFields.propTypes = {
  amount: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool
};

function PercentInsuredFields({ percent, cost, quantity, disabled }) {
  const costValue = cost.input.value || 0;
  const quantityValue = quantity.input.value || 0;
  const percentValue = percent.input.value || 0;
  const subtotal = parseFloat(costValue) * parseFloat(quantityValue);
  const insuranceAmount = Math.ceil(subtotal * percentValue) / 100;

  return (
    <Col md={12}>
      <FormRow>
        <Col md={4}>
          <Field
            name={percent.input.name}
            label="Insurance Percent"
            component={NumberInput}
            inputProps={{
              min: "0"
            }}
            parse={value => value && parseInt(value, 10)}
            addon={<i className="fa fa-percent" />}
            disabled={disabled}
            required
          />
        </Col>
        <Col md={4}>
          <div className="form-group">
            <label className="control-label" htmlFor="insurance_type">
              Insurance Amount
            </label>
            <div className="input-group">
              <span className="input-group-addon">
                <i className="fa fa-dollar" />
              </span>
              <input
                className="form-control"
                type="text"
                value={insuranceAmount}
                disabled
                readOnly
              />
            </div>
          </div>
        </Col>
      </FormRow>
    </Col>
  );
}

PercentInsuredFields.propTypes = {
  percent: PropTypes.instanceOf(Object),
  cost: PropTypes.instanceOf(Object),
  quantity: PropTypes.instanceOf(Object),
  disabled: PropTypes.bool
};

export function InsuranceFields({
  amount_insured: amountInsured,
  percent_insured: percentInsured,
  insurance_type: insuranceType,
  part_cost: partCost,
  quantity,
  disabled
}) {
  if (insuranceType.input.value === "Amount") {
    return <AmountInsuredFields amount={amountInsured} disabled={disabled} />;
  } else if (insuranceType.input.value === "Percent") {
    return (
      <PercentInsuredFields
        insuranceType={insuranceType}
        percent={percentInsured}
        cost={partCost}
        quantity={quantity}
        disabled={disabled}
      />
    );
  }

  return null;
}

InsuranceFields.propTypes = {
  amount_insured: PropTypes.instanceOf(Object),
  percent_insured: PropTypes.instanceOf(Object),
  insurance_type: PropTypes.instanceOf(Object),
  disabled: PropTypes.bool,
  part_cost: PropTypes.instanceOf(Object),
  quantity: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/ShippingSection/InsuranceFields.jsx